import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '../lib/utils'
import { Label } from './ui/label'
import { DateRangePicker, type DateRangeValue } from './date-range-picker'

type Props = {
 label?: string
 value: DateRangeValue | { from?: string | null; to?: string | null }
 onChange: (value: DateRangeValue) => void
 placeholder?: string
 disabled?: boolean
 clearable?: boolean
 includeAllTimePreset?: boolean
 rememberPreset?: boolean
 includeTime?: boolean
 className?: string
 showLabel?: boolean
 id?: string
}

export function DateRangeFilterField({
 label,
 value,
 onChange,
 placeholder,
 disabled,
 clearable = true,
 includeAllTimePreset = true,
 rememberPreset = false,
 includeTime = false,
 className,
 showLabel = true,
 id,
}: Props) {
 const { t } = useTranslation()
 const resolvedLabel = label ?? t('ui.dateRange.label')
 const resolvedPlaceholder = placeholder ?? t('ui.dateRange.placeholder')

 return (
  <div className={cn('flex min-w-[min(100%,280px)] flex-col gap-1', className)}>
   {showLabel ? (
    <Label htmlFor={id} className="text-[13px] font-semibold text-foreground/80">
     {resolvedLabel}
    </Label>
   ) : null}
   <DateRangePicker
    id={id}
    value={{
     from: value.from ?? null,
     to: value.to ?? null,
    }}
    onChange={onChange}
    placeholder={resolvedPlaceholder}
    disabled={disabled}
    clearable={clearable}
    includeAllTimePreset={includeAllTimePreset}
    rememberPreset={rememberPreset}
    includeTime={includeTime}
   />
  </div>
 )
}
